import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader } from '@lms/ui';
import { SafeHtml } from '@/components/SafeHtml';
import { api } from '@/lib/api';
import type { LegalPolicyPublicDetail } from './types';

export function LegalPolicyPage() {
  const { slug } = useParams<{ slug: string }>();

  const { data, isLoading, error } = useQuery({
    queryKey: ['legal-policies', 'public', slug],
    queryFn: () => api<LegalPolicyPublicDetail>(`/legal/policies/by-slug/${slug}`),
    enabled: Boolean(slug),
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface px-4">
        <Loader label="Cargando política…" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface px-4">
        <p className="text-on-surface-variant">La política solicitada no está disponible.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface px-4 py-10">
      <article className="mx-auto max-w-3xl rounded-2xl bg-white p-8 shadow-sm">
        <header className="mb-8 border-b border-outline-variant pb-6">
          <h1 className="text-3xl font-semibold text-dash-primary">{data.title}</h1>
          <p className="mt-2 text-sm text-on-surface-variant">
            Versión {data.version}
            {data.publishedAt
              ? ` · Publicada ${new Date(data.publishedAt).toLocaleDateString('es-ES')}`
              : ''}
          </p>
        </header>
        <SafeHtml html={data.bodyHtml} className="prose max-w-none legal-policy-public-content" />
      </article>
    </div>
  );
}
